import { roundValue } from 'ps-components/lib/formatters';

export function getIndexOfElement(collection, element) {
  return collection.indexOf(element);
}

export function getInteralAvgHeaderRow(data) {
  let headerData = [];
  const labels = data.surveyData[0].map(row => row[0]);
  const basePayIndex = labels.indexOf('Base Salary');
  const totalCashIndex = labels.indexOf('Total Cash');

  // MPE-5608: Lodash cleanup, findIndex
  const indexOfBasePay50th = data?.surveyData[0][basePayIndex]?.findIndex(element => {
    return element.field && element.field?.default_title?.includes('50');
  });

  const indexOfTotalCash50th = data?.surveyData[0][totalCashIndex]?.findIndex(element => {
    return element.field && element.field?.default_title?.includes('50');
  });

  data.surveyData[0].forEach((row, index) => {
    if (index === basePayIndex) {
      row.map((element, index) => {
        if (index !== 0) {
          if (index === indexOfBasePay50th) {
            headerData.push('Internal Avg');
          } else if (index === indexOfBasePay50th + 1) {
            headerData.push('Mkt Ratio (50th)');
          } else {
            headerData.push(null);
          }
        }
      });
    } else if (index === totalCashIndex) {
      row.map((element, index) => {
        if (index !== 0) {
          if (index === indexOfTotalCash50th) {
            headerData.push('Internal Avg');
          } else if (index === indexOfTotalCash50th + 1) {
            headerData.push('Mkt Ratio (50th)');
          } else {
            headerData.push(null);
          }
        }
      });
    } else {
      row.map((element, index) => {
        if (index !== 0) {
          headerData.push(null);
        }
      });
    }
  });
  return headerData;
}

export function getInternalAvgBodyRow(data, rows, columns, monetaryRounding, percentRounding) {
  const dataRow = [];
  const labels = data.surveyData[0].map(row => row[0]);
  const basePayIndex = labels.indexOf('Base Salary');
  const totalCashIndex = labels.indexOf('Total Cash');
  const baseSalaryAvg = getIndexOfElement(columns, 'Base Salary Amt');
  const totalCashAvg = getIndexOfElement(columns, 'Total Paid Cash Amt');

  // MPE-5608: Lodash cleanup, findIndex
  const indexOfBasePay50th = data?.surveyData[0][basePayIndex]?.findIndex(element => {
    return element.field && element.field?.default_title?.includes('50');
  });

  const indexOfTotalCash50th = data?.surveyData[0][totalCashIndex]?.findIndex(element => {
    return element.field && element.field?.default_title?.includes('50');
  });

  const basePayRatio =
    basePayIndex >= 0 && data.surveyData[0][basePayIndex][indexOfBasePay50th]
      ? (rows[0][baseSalaryAvg] / data.surveyData[0][basePayIndex][indexOfBasePay50th].value) * 100
      : null;
  const totalCashRatio =
    totalCashIndex >= 0 && data.surveyData[0][totalCashIndex][indexOfTotalCash50th]
      ? (rows[0][totalCashAvg] / data.surveyData[0][totalCashIndex][indexOfTotalCash50th].value) * 100
      : null;

  data.surveyData[0].forEach((row, index) => {
    if (index === basePayIndex) {
      row.map((element, index) => {
        if (index !== 0) {
          if (index === indexOfBasePay50th && row[0] === 'Base Salary' && rows[0][baseSalaryAvg] !== null) {
            dataRow.push(roundValue(rows[0][baseSalaryAvg], monetaryRounding));
          } else if (index === indexOfBasePay50th + 1 && row[0] === 'Base Salary' && basePayRatio !== null) {
            dataRow.push(roundValue(Math.round(basePayRatio * 100) / 100, percentRounding));
          } else {
            dataRow.push(null);
          }
        }
      });
    } else if (index === totalCashIndex) {
      row.map((element, index) => {
        if (index !== 0) {
          if (index === indexOfTotalCash50th && row[0] === 'Total Cash' && rows[0][totalCashAvg] !== null) {
            dataRow.push(roundValue(rows[0][totalCashAvg], monetaryRounding));
          } else if (index === indexOfTotalCash50th + 1 && row[0] === 'Total Cash' && totalCashRatio !== null) {
            dataRow.push(roundValue(Math.round(totalCashRatio * 100) / 100, percentRounding));
          } else {
            dataRow.push(null);
          }
        }
      });
    } else {
      row.map((element, index) => {
        if (index !== 0) {
          dataRow.push(null);
        }
      });
    }
  });
  return dataRow;
}

export function getInternalAvgData(data, rows, columns, monetaryRounding, percentRounding) {
  if (
    data.columnHeaders.includes('50th') &&
    (columns.includes('Market Base Salary 50th (Median)') || columns.includes('Market Total Cash 50th (Median)'))
  ) {
    const indexOf50th = data.columnHeaders.indexOf('50th');
    if (data.columnHeaders.length === indexOf50th + 1) data.columnHeaders.push(' ');

    return {
      headerData: getInteralAvgHeaderRow(data),
      rowData: getInternalAvgBodyRow(data, rows, columns, monetaryRounding, percentRounding)
    };
  } else {
    return {
      headerData: [],
      rowData: []
    };
  }
}

export function getRoundedValue(element, fieldType, monetaryRounding, percentRounding, numericRounding) {
  const isNumberType = fieldType === 'monetary' || fieldType === 'percent' || fieldType === 'number';
  const roundTo = getRoundToValue(fieldType, monetaryRounding, percentRounding, numericRounding);

  return isNumberType ? roundValue(element, roundTo) : element;
}

export function getRoundToValue(fieldType, monetaryRounding, percentRounding, numericRounding) {
  let roundTo;
  switch (fieldType) {
    case 'monetary':
      roundTo = monetaryRounding;
      break;
    case 'percent':
      roundTo = percentRounding;
      break;
    case 'number':
      roundTo = numericRounding;
      break;
    default:
      roundTo = 0;
  }

  return roundTo;
}

export function getPdfSubsetIndex(data) {
  let total = 0,
    index = 0;

  for (let i = 0; total <= 830 && i <= data.fields.length - 1; i++) {
    total += Math.round((data.fields[i].default_title.toString().length * 12) / 2) + 5;
    index = i;
  }

  return index + 1;
}
